'use strict';

angular.module('licensure.services')
    .factory('EntityEnterpriseFields', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/entityenterprisefields', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
            getByCategory: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/entityenterprisefields', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },
            getCategoryQuestions: function (category) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/entityenterprisefields/getcategoryquestions', {
                    params: {
                        category: category
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;